import { cn } from '@/lib/utils';
import { MessageSquare, Mic } from 'lucide-react';
import { useLocation } from 'wouter';

type Mode = 'dictation' | 'conversation';

interface ModeSwitcherProps {
  activeMode: Mode;
}

const activeClasses = 'bg-white text-primary shadow-sm';
const inactiveClasses = 'text-muted-foreground hover:text-foreground';

export const ModeSwitcher = ({ activeMode }: ModeSwitcherProps) => {
  const [, navigate] = useLocation();

  return (
    <div className="flex h-12 rounded-lg bg-slate-100 p-1">
      <button
        type="button"
        onClick={activeMode === 'dictation' ? undefined : () => navigate('/dictation/new?modeSwitch=true')}
        className={cn(
          'flex w-15 cursor-pointer items-center gap-1.5 rounded-md px-2.5 py-1.5 font-medium text-xs transition-all sm:w-auto md:gap-2 md:px-3 md:py-1.5 md:text-sm',
          activeMode === 'dictation' ? activeClasses : inactiveClasses
        )}
      >
        <Mic className="mx-auto h-4 w-4" />
        <span className="hidden sm:inline">Diktering</span>
      </button>
      <button
        type="button"
        onClick={activeMode === 'conversation' ? undefined : () => navigate('/conversation/new?modeSwitch=true')}
        className={cn(
          'flex w-15 cursor-pointer items-center gap-1.5 rounded-md px-2.5 py-1.5 font-medium text-xs transition-all sm:w-auto md:gap-2 md:px-3 md:py-1.5 md:text-sm',
          activeMode === 'conversation' ? activeClasses : inactiveClasses
        )}
      >
        <MessageSquare className="mx-auto h-4 w-4" />
        <span className="hidden sm:inline">Viðtal</span>
      </button>
    </div>
  );
};
